<template>
  <section>
      <div id="backBox"></div>
      <Navbar />
      <div class="mainFlex">
        <!-- FIRST COLUMN -->
        <div class="flexLeft">
          <Groups />
        </div>

        <!-- MAIN BLOCK -->
        <div class="profileCalBox">
          <p>profile calendar</p>
        </div>
      </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Groups from "@/components/Groups";
import Navbar from "@/components/Navbar";

export default {
  components: {
      Groups,
      Navbar,
  },

  computed: {
    ...mapState("messageBoard", ["groupId","groupName"]),
  },
}
</script>

<style src="@/styles/views/ProfileCalendar.css"></style>